import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, ListGroup, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';

export default class ProposalList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "propertyProposals",
            dataRecord: "propertyProposals",
            dataSetPrimaryKey: "property_proposal_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
    
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        this.setState({ isLoading: false });      
    }

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }



    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;

        if(cellInfo.column.id==="proceeded"){
            if(event.target.checked){
                alert("You have selected that the proposal is completed so the current and include in text flags have been set to false");
                data[cellInfo.index].current= false;
                data[cellInfo.index].include_in_text= false;
                data[cellInfo.index].approved= true;
            }
        }

        if(cellInfo.column.id==="current" || cellInfo.column.id==="include_in_text"){
            if(event.target.checked){
                console.log(cellInfo.original);
                if(cellInfo.original.proceeded==true){ 
                    alert("The proposal was completed but you selected that it is current or to include in text. The completed flag has been set to false");
                    data[cellInfo.index].proceeded= false;
                        
                }
                
            }
        }




        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(event);
        data[cellInfo.index][cellInfo.column.id] = dt.toLocaleDateString('en-AU',options);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];

        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }
        }   
        if (data[0].hasOwnProperty("source_date")) {
            data.sort(function (a, b) { return new Date(b.source_date) - new Date(a.source_date) });
        }
        if (data[0].hasOwnProperty("current")) {
            data.sort(function (a, b) { return  (a.current === b.current)? 0 : a.current? -1 : 1 });
        }

        this.props.updateTableState(data, this.state.dataSet);

    }


    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.unshift({
            property_id: null,
            property_key: "",
            addresses: null,
            proposal_id: this.props.proposalid,
            alternate_text: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }

 

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (["proposal","alternate_text"].indexOf(cellInfo.column.id) >= 0) {
            if (cellValue) {
                return (
                <Form.Control
                onChange={this.handleInputChange.bind(null, cellInfo)}
                value={cellValue}
                as="textarea"
                rows="2"
                className="no-border form-control"
                onBlur={this.handleSave.bind(null, cellInfo)}
            />
                );
            }
        
        }
        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }



    renderTable(data) {
        const columns = [

            {
                id: 'proposal_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'proposal_id' ,
                Cell: e => <LinkContainer to={{ pathname:`/properties/${e.original.property_key}/proposals/${e.value}`, state: {data: this.props.data.map(a => a.proposal_id),propertyidlist: this.props.idList}}}><a> {e.value} </a></LinkContainer>

            }, {
                id: 'source_date',
                Header: 'Source Date',
                accessor: 'source_date',
                maxWidth: 100,
                Cell: this.renderEditable

            },
            {
                id: 'current',
                Header: 'Current',
                accessor: 'current',
                maxWidth: 100,
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                id: 'include_in_text',
                Header: 'In Text',
                accessor: 'include_in_text',
                maxWidth: 100,
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                id: 'proceeded',
                Header: 'Proceeded',
                accessor: 'proceeded',
                maxWidth: 100,
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            }
            , {
                id: 'proposal', // Required because our accessor is not a string
                Header: 'Proposal',
                accessor: 'proposal',
                Cell: this.renderEditable
            }, {
                id: 'alternate_text', // Required because our accessor is not a string
                Header: 'Alternate Text',
                accessor: 'alternate_text',
                Cell: this.renderEditable
            },
            {
                Header: '',
                accessor: 'property_proposal_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }


    renderTable2(data) {
        const columns = [

            {
                id: 'property_key',
                Header: '',
                accessor: 'property_key',
                maxWidth: 65,
                style: { 'white-space': 'unset' },
                Cell: e=> <LinkContainer to={`/properties/${e.original.property_key}`} ><Button  type="button" size="sm" variant="primary">Back</Button></LinkContainer>
            }, {
                id: 'property_key',
                Header: 'Cityscope Ref',
                accessor: 'property_key',
                maxWidth: 100,
                style: { 'white-space': 'unset' },
                Cell: this.renderEditable
            },
            {
                id: 'main_property_address',
                Header: 'Main Property Address',
                accessor: 'main_property_address',
                maxWidth: 200,
                style: { 'white-space': 'unset' },
                Cell: e => {
                    if (!e.original.addresses || e.original.addresses.length === 0) return <span></span>
                    const mainAddresses = e.original.addresses.filter(a => a.main_address === true);
                    if (mainAddresses.length === 0) return <span></span>
                    const mainAddress = mainAddresses[0]
                    return <span>{ `${mainAddress.street_address}, ${mainAddress.suburb}`}</span>
                }
            },
            {
                id: 'alternate_text', // Required because our accessor is not a string
                Header: 'Alternate Text',
                accessor: 'alternate_text',
                style: { 'white-space': 'unset' },
                Cell: this.renderEditable
            }, {
                id: 'site_area',
                Header: 'Site Area',
                accessor: 'site_area',
                maxWidth: 65,
                style: { textAlign: "right", 'white-space': 'unset' },
                Footer:  'Total: ' + this.props.areaSum                            
            }
            , {
                id: 'title_details',
                Header: 'Title',
                accessor: 'title_details',
                style: { 'white-space': 'unset' },
            },
            {
                Header: '',
                accessor: 'property_proposal_id',
                maxWidth: 65,
                style: { 'white-space': 'unset' },
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                />
            )
        }



    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ? <LinkContainer key={i}  to={`/properties/${d.property_key}`}>
                        <ListGroup.Item key={i} as="a" header={d.property_key}>
                             {d.property_key}
                            </ListGroup.Item>
                        </LinkContainer>
                        : ""
            );
        }
    }


    renderComponent() {
        return (
            <div className="proposals">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>

                {(this.props.controlType === "table" || this.props.controlType === "table2") && <Row >
                    <Col className="text-right" >
                        {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        {this.props.controlType === "table" && <LinkContainer to={`/properties/${this.props.propertykey}/proposals/new?propertyid=${this.props.propertyid}`}><Button variant="secondary" size="sm">Add</Button></LinkContainer>}
                        {this.props.controlType === "table2" && <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>}

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.props.controlType === "table2" ? this.renderTable2(this.props.data) :this.renderList(this.props.data)}
                        </Col>
                    </Row>
       

            </div>
        );
    }
  render() {
    return (

        <div className="ProposalList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
